import { getGuestGenderByTitle } from '@utils/helpers';
import { Guest } from 'shared-types/Basket';

export const mapLoggedInUserToGuest = (loggedInGuest: Guest) =>
  loggedInGuest && loggedInGuest.firstName && loggedInGuest.lastName
    ? {
        ...loggedInGuest,
        title: loggedInGuest.title || '',
        gender: loggedInGuest.gender || getGuestGenderByTitle(loggedInGuest?.title),
        ...(loggedInGuest.externalSpaId
          ? { externalSpaId: loggedInGuest.externalSpaId }
          : { isLead: true }),
        loggedInUser: loggedInGuest.id ? { id: loggedInGuest.id } : undefined,
        id: undefined,
      }
    : null;
